<template>
  <div class="aboutUs">
    <div class="topPart">
      <!-- <img src="@/assets/image/logo.png" alt="" class="logo" /> -->
      <div class="companyName">请选择反馈方式</div>
      <div class="version">我们将尽力提供帮助</div>
    </div>
    <div class="itemGroup">
      <div v-for="(item, index) in cellList" :key="index" class="itemCell tapActive" @click="handelMethedName(item.methedName)">
        <div class="leftPart">
          <span :class="item.iconfont" class="iconfont icon"></span>
          <div class="text" v-text="item.name"></div>
        </div>
        <i class="iconfont icon-jiantou iconRight"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GetRidiculeEntranceCfg } from '@/api/my'
const RID_ICULE_ENTRANCE_CFG_TYPE = {
  关: '0',
  开: '1'
}

export default {
  name: 'AboutUs',
  data() {
    return {
      version: 'v1.1.0',
      cellList: []
    }
  },
  computed: {
    ...mapGetters(['getIsApp'])
  },
  beforeCreate() {
    this.RID_ICULE_ENTRANCE_CFG_TYPE = RID_ICULE_ENTRANCE_CFG_TYPE
  },
  mounted() {
    this.getRidiculeEntranceCfg()
  },
  methods: {
    handelMethedName(methedName) {
      this[methedName]()
    },
    contactCs() {
      this.limitDialogShow = false
      if (this.getIsApp) {
        this.$uni.postMessage({
          data: {
            linkToContactCustomerService: true
          }
        })
      } else {
        this.$router.push({
          name: 'posterDetail',
          query: {
            isContact: 1
          }
        })
      }
    },
    makeComplaints() {
      if (this.getIsApp) {
        this.$uni.postMessage({
          data: {
            outsideLink: true,
            tempLink: 'https://support.qq.com/products/59252?'
          }
        })
      } else {
        window.location.href = 'https://support.qq.com/products/59252?'
      }
    },
    // 获取APP吐槽入口开关配置接口
    async getRidiculeEntranceCfg() {
      let tempCellList = [
        {
          iconfont: 'icon-lianxikefu',
          name: '联系客服',
          methedName: 'contactCs'
        }
      ]
      try {
        if (this.getIsApp) {
          const { Data } = await GetRidiculeEntranceCfg()
          if (Data === this.RID_ICULE_ENTRANCE_CFG_TYPE['开']) {
            tempCellList.push({
              iconfont: 'icon-lianxikefu1',
              name: '吐槽反馈',
              methedName: 'makeComplaints'
            })
          }
        } else {
          tempCellList.push({
            iconfont: 'icon-lianxikefu1',
            name: '吐槽反馈',
            methedName: 'makeComplaints'
          })
        }
        this.cellList = tempCellList
      } catch (err) {
        this.$toast(err.ErrMsg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.aboutUs {
  display: flex;
  flex-direction: column;
  padding: 0 30px 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #fff;

  .topPart {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 60px 0 46px;

    .companyName {
      font-size: 20px;
      font-weight: 700;
      //   margin: 12px 0;
      span {
        letter-spacing: 12px;
      }
    }

    .version {
      color: #898989;
    }
  }

  .itemGroup {
    width: 100%;

    .itemCell {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      border-bottom: 1px solid #f2f2f2;

      .leftPart {
        display: flex;
        align-items: center;
        font-size: 14px;

        .icon {
          font-size: 20px;
          margin-right: 10px;
        }
      }

      .iconRight {
        font-size: 12px;
      }
    }
  }
}
</style>
